// Bottom bar of phones and tablets (hidden from 1024 px, where the top navigation takes over). The landmark
// wrapper hides with the bar, so no empty "Hauptnavigation" remains for screen readers at the desk.

import { useT } from "../../lib/i18n";
import { NavEntry } from "./NavEntry";
import { navItems } from "./navigation";
import styles from "./shell.module.css";

export function BottomNav() {
  const t = useT();
  return (
    <nav className={styles.bottomNav} aria-label={t("shell.nav")}>
      <ul className="sf-bottomnav">
        {navItems
          .filter((item) => item.phone)
          .map((item) => (
          <li key={item.id}>
            <NavEntry item={item} variant="bottom" />
          </li>
        ))}
      </ul>
    </nav>
  );
}
